module.exports = __webpack_public_path__ + "static/media/Lugia_gaussian2.191ef474.png";